import tippy from "tippy.js";

document.addEventListener("DOMContentLoaded", () => {
    reInitAllTooltips()
});

export function reInitAllTooltips() {
    const allTooltipButtons = document.querySelectorAll(".tooltip-btn");

    if (allTooltipButtons.length) {
        allTooltipButtons.forEach((btn) => {
            const message = btn.dataset.message;

            if (message) {
                tippy(btn, {
                    theme: "light-border",
                    content: message,
                    placement: "right",
                    maxWidth: 180,
                });
            }
        });
    }
}
